import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { selectMainState } from '@/msgdeskRuntime/state'
import { useSubsStore } from '@/state/MsgTreeProvider'

export function FacebookSlideTemplate({ display, controls, slots }: SubTemplateProps) {
  const { state } = useSubsStore()
  const main = selectMainState(state)
  const outgoing = Boolean(
    (display.codeKey && main.codeKey && display.codeKey === main.codeKey)
    || (display.identity.author && main.author && display.identity.author === main.author),
  )
  const photo = display.permissions.canViewContent && !display.access.isContentLocked
    ? display.media.primaryAttachment
    : undefined
  const photoSrc = photo?.src || photo?.thumbSrc
  return (
    <>
      <div className={`md-subs-facebook-row flex px-5 py-1 text-[15px] font-[-apple-system,BlinkMacSystemFont,'Segoe_UI',Roboto,Oxygen,Ubuntu,Cantarell,sans-serif] ${outgoing ? 'justify-end' : 'justify-start'}`}>
        <div className={`md-subs-facebook-bubble max-w-[70%] rounded-[18px] px-3 py-2 ${outgoing ? 'rounded-br bg-[#0084ff] text-white' : 'rounded-bl bg-[#f0f0f0] text-[#050505]'}${display.isChecked ? ' ring-2 ring-[#0084ff]' : ''}`}>
          <div className={`md-subs-facebook-title text-[13px] font-semibold ${outgoing ? '[&_.md-sub-title-link]:text-white' : '[&_.md-sub-title-link]:text-[#050505]'}`}>
            {controls.content.title}
          </div>
          <div className={`md-subs-facebook-text mt-1 leading-[1.3] [overflow-wrap:anywhere] [&_.md-sub-text]:whitespace-normal ${outgoing ? '[&_.md-sub-text]:text-white' : '[&_.md-sub-text]:text-[#050505]'}`}>
            {controls.content.text}
          </div>
          {photoSrc ? <img className="mt-2 max-h-[420px] max-w-full rounded-xl object-cover" src={photoSrc} alt={photo.title || photo.filename || display.title} /> : null}
          <div className={`md-subs-facebook-meta mt-1 flex items-center gap-2 text-[11px] ${outgoing ? 'text-white/80' : 'text-[#65676b]'}`}>
            {controls.actions.check}
            {controls.content.time}
            {controls.actions.favorite}
            {controls.actions.quickReply}
          </div>
        </div>
      </div>
      <div className={outgoing ? 'md-subs-facebook-children mr-12' : 'md-subs-facebook-children ml-12'}>{slots.allChildren}</div>
    </>
  )
}
